import React from 'react'
import { PricingPlan } from '../types'
import { PricingPlanElement } from '../pricingPlan'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import ActionButton from 'uiComponents/buttons'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import './confirmActionModal.scss'
import { t } from 'translations'

type ConfirmableAction = 'activate' | 'discontinue'

const getActionCopy = (): Record<ConfirmableAction, { title: string; body: string; button: string }> => ({
    activate: {
        title: t('products.pricing.pricingPlans.confirmModal.activate.title'),
        body: t('products.pricing.pricingPlans.confirmModal.activate.body'),
        button: t('products.pricing.pricingPlans.confirmModal.activate.button'),
    },
    discontinue: {
        title: t('products.pricing.pricingPlans.confirmModal.discontinue.title'),
        body: t('products.pricing.pricingPlans.confirmModal.discontinue.body'),
        button: t('products.pricing.pricingPlans.confirmModal.discontinue.button'),
    },
})

interface ConfirmActionModalProps {
    pricingPlan: PricingPlan
    action: ConfirmableAction
    onConfirm: () => void
    onDismiss: () => void
}

export const ConfirmActionModal = ({ pricingPlan, action, onConfirm, onDismiss }: ConfirmActionModalProps) => {
    const copy = getActionCopy()[action]

    return (
        <Modal className="confirm-action-modal" title={copy.title} onDismiss={onDismiss}>
            <ModalBody>
                <p>{copy.body}</p>
                <PricingPlanElement pricingPlan={pricingPlan} readOnly />
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onDismiss} size="large" />
                <ActionButton size="large" onClick={onConfirm}>
                    {copy.button}
                </ActionButton>
            </ModalFooter>
        </Modal>
    )
}
